<div class="input-container">
  <select
    class="input"
    [(ngModel)]="value"
    (ngModelChange)="handleSelection()"
  >
    <option [value]="undefined" disabled hidden>{{ placeholderText }}</option>

    <option [value]="null" disabled hidden>{{ placeholderText }}</option>

    <ng-container *ngFor="let item of possibleValues">
      <option [value]="item" [selected]="item === value">{{ getItemDisplayValue(item) }}</option>
    </ng-container>
  </select>

  <div class="icon">
    <app-lucide-icon [iconName]="'chevron-down'" [size]="36"></app-lucide-icon>
  </div>
</div>
